module.exports = __webpack_public_path__ + "img/report-6.b035cf7f.jpeg";